import { createAction } from '@reduxjs/toolkit'

export const convertLink = createAction('converter/convertLink')
